var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JBox',[_c('CFormInput',_vm._g({attrs:{"componentName":"JSelect","name":"options","value":_vm.value,"options":_vm.options}},Object.assign({}, _vm.$listeners, {focus: function (e) { return _vm.fetchOptions(); }})))],1)}
var staticRenderFns = []

export { render, staticRenderFns }